import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';

import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import beautify from 'xml-beautifier';
import { LoginService } from "src/app/components/Shared/Service/login_service";
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: Date;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-bitsila-log',
  templateUrl: './bitsila-log.component.html',
  styleUrls: ['./bitsila-log.component.css'],
  providers: [LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class BitsilaLogComponent implements OnInit {
  Val: string;
  hotellistproperty: any = []
  lstBooking: any = [];
  // public client: Client;
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  displayedColumns = ['recordtype','receivedJSON','uploadJSON', 'responseJSON', 'createdatetime','responseDatetime'];
  apiresult: any;
  Pmscodevalue: any;
  errorMsgSubscription: boolean;
  errorMessage: string;
  displayContent: boolean;
  selectedDateStore: any;
  selectedTOODateStore: any;
  filterProperty: any;
  blinkOfflineHotel: boolean;
  currentDateStore: any;
  storeHeartBeatValue: any;
  defaultData: any;
  XMLName: any;
  businessStoreName: any;
  dH_Config_ID: any;
  store_id: any;
  business_name: any;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, 
    private datePipe: DatePipe) { 
      
    }

  display: Boolean = false;
  public User: string;
  today = new Date();
  today1 = new Date();
  today2 = new Date()
  lastThirthydays: any = new Date(this.today2.setDate(this.today2.getDate() - 30));
  selectedDate: any = new Date(this.today.setDate(this.today.getDate()));
  selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate()));
  isProgressing: Boolean = false;
  lstGetCMHotelsProperty: any = [];
  storePmsCode: string
  Userid: any = [];
  selectedProperty: any;
  isIDSUser: boolean;
  search: string;
  totalcount: any = 0;
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any
  checkTodayDate:any
  CurrentDate = new Date();
  searchBarFilter: boolean = false;
  addBtnDisabledFunc: boolean = true;
  hideSearchFilter(){
    this.Val = '';
    this.searchBarFilter = false
  }
ngOnInit() {
    // this.checkTodayDate = this.CurrentDate.getDate()
    // console.log('check Today =', this.checkTodayDate)
    // this.isProgressing = true;
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    // this.errorMsgSubscription = true
    // this.statusResult = "Not Sent"
    // this.errorMessage = "Please select Store Id and load"
    // this.displayContent = false
    this.BitsilaLogBusinessList();
    // this.GetLoadMethodIDSUser()
    this.dropdownSettingsDept = {
      idField: 'dH_Config_ID',
      textField: 'business_name',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Business / Store Name"
    };
  }
  // GetParseonlyDateTimeHeartbeat(d:any) {
  //   // console.log('GetParseonlyDateTimeHeartbeat',d)
  //   // if (d == "") {
  //   //   return "";
  //   // }
  //   console.log('GetParseonlyDateTimeHeartbeat = ',d.substring(0, 2))
  //   return (d.substring(0, 2));
  // }

  GetParseonlyDateTimeHeartbeat(d:any) {
    var dt1 = new Date(d);
    var dt2 = new Date();
    // console.log('dt1 = ',dt1)
    // console.log('dt2 = ',dt2)
    var diff =(dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    // console.log('Math ABS = ',Math.abs(Math.round(diff)));
    if(Math.abs(Math.round(diff)) > 60){
      return false
    }else{
      return true
    }
      }

  GetHeartbeatDateTime(heartBeatData:any) {
    console.log('GetHeartbeatDateTime call',heartBeatData)
// For blinking the record
const today = new Date()
        console.log('Today Date = ',today);
        this.currentDateStore = today.toLocaleTimeString('it-IT')
        console.log('Today Date = ',this.currentDateStore);
        this.storeHeartBeatValue = this.GetHeartbeatTime(heartBeatData)
// this.storeHeartBeatValue = heartBeatData
var start = this.storeHeartBeatValue.split(":");
var end = this.currentDateStore.split(":");
var startDate = new Date(0, 0, 0, start[0], start[1], 0);
var endDate = new Date(0, 0, 0, end[0], end[1], 0);
var diff = endDate.getTime() - startDate.getTime();
var hours = Math.floor(diff / 1000 / 60 / 60);
diff -= hours * 1000 * 60 * 60;
var minutes = Math.floor(diff / 1000 / 60);
console.log('minutes difference', hours + ":"  + minutes)
if((hours + ":"  + minutes) > "0:30"){
  console.log('blinkOfflineHotel true')
  this.blinkOfflineHotel = true
  // return heartBeatData
}else{
  console.log('blinkOfflineHotel false')
  this.blinkOfflineHotel = false
  // return heartBeatData
} 
return heartBeatData
  }

  
  
  GetHeartbeatTime(d:any) {
    console.log('GetHeartbeatTime call = ',d.substring(12))
    return (d.substring(12));
  }

  BitsilaLogBusinessList() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getBusinessList()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          // this.apiresult.unshift({
          //   "propertyCode": "All",
          //   "propertyName": "All Property"
          // });

          this.dropdownDeptData = this.apiresult
          console.log('this.dropdownDeptData', this.dropdownDeptData);
          // if (this.SourceBy == 'Report') {
          // this.selectedDeptItems = this.getDimensionsByFilter("All");
          // console.log('this.StoreValuetest', this.selectedDeptItems[0].propertyCode);
          // this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
          // console.log('this.Pmscodevalue =', this.Pmscodevalue)
          // // }
          // console.log('Property 113 = ', data)
          this.errorMsgSubscription = true
            this.errorMessage = "Please Select Business / Store Name and Load"
          this.isProgressing = false;
        });
  }


  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      this.searchBarFilter = false
      this.Val = '';
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please Select Business / Store Name and Load"
        this.displayContent = false
        this.dH_Config_ID = this.selectedDeptItems[0].dH_Config_ID
        // this.store_id = this.selectedDeptItems[0].store_id
        this.business_name = this.selectedDeptItems[0].business_name
        console.log('dH_Config_ID = ', this.dH_Config_ID)
        console.log('store_id = ', this.store_id)
        console.log('business_name = ', this.business_name)
        var result=this.apiresult.filter((obj: { dH_Config_ID: MatSelectChange; })=> obj.dH_Config_ID == this.dH_Config_ID);
        console.log('filter record = ',result[0].store_id);
this.businessStoreName = result[0].store_id
this.store_id = result[0].store_id
console.log('businessStoreName = ',this.businessStoreName);
this.addBtnDisabledFunc = false
      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please Select Business / Store Name and Load"
        this.displayContent = false
        this.addBtnDisabledFunc = true
        this.businessStoreName = ''
      }
    } else {
      console.log('Property Not Selected')
    }
  }
  getDimensionsByFilter(propertyCode: any) {
    console.log('dropdownDeptData =', this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }


   GetLoadMethodIDSUser() {
    this.searchBarFilter = true
    this.isProgressing = true;
    this.selectedDateStore = this.datePipe.transform(this.selectedDate, 'yyyyMMdd');
    this.selectedTOODateStore = this.datePipe.transform(this.selectedTOODate, 'yyyyMMdd');
    console.log('selectedProperty Result = ', this.Pmscodevalue)
    console.log('selectedDate Result = ', this.selectedDateStore)
    console.log('selectedTOODate Result = ', this.selectedTOODateStore)
    console.log('dH_Config_ID Result = ', this.dH_Config_ID)
    console.log('store_id Result = ', this.store_id)
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    } else {
      this.apiCallIdsService.BitsilaLogAPI(this.selectedDateStore, this.selectedTOODateStore,this.dH_Config_ID, this.store_id)
        .subscribe((data) => {
          console.log('response =', data);
          if (data.length < 1) {
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
          else {
            this.errorMsgSubscription = false
            this.displayContent = true
            this.idsProductList = data;
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          }
        });
    }
  }

  Search(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { pmscode: { toString: () => string; }; pmsname: { toString: () => string; } }) => {
      return res.pmscode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.pmsname.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if (event == '') {
      this.Val = '';
    }
  }
  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
  showJSON(JSON: any,xmltype:any) {
    console.log('JSON', JSON)
    this.isProgressing = true;
    this.defaultData = JSON
    if(xmltype == 'uploadJSON'){
      this.XMLName = "Upload JSON"
    }else if(xmltype == 'receivedJSON'){
      this.XMLName = "Received JSON"
    }else{
      this.XMLName = "Response JSON"
    }
    console.log('JSON ====', this.defaultData)
    setTimeout(() => {
      this.display = true;
    this.isProgressing = false;
    }, 1000);
    
}
}
